import { FC, ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import { PanelModal } from "shared/components/PanelModal"
import { P } from "shared/styles/textStyles"
import styled from "styled-components"

const ErrorHeading = styled(P)`
  margin: 5px 0;
  color: ${(props) => props.theme.colors.error};
  font-weight: 700;
  padding: 0 5px;
`

export const ErrorBody = styled(P)`
  margin: 3px 0 0;
  color: ${(props) => props.theme.text.dark};
  padding: 0 5px;

  &:last-of-type {
    margin-bottom: 10px;
  }
`

interface ErrorModalProps {
  showHeading?: boolean
  closeModal: () => void
  children?: ReactNode
}

const ErrorModal: FC<ErrorModalProps> = ({
  closeModal,
  showHeading = true,
  children,
}) => {
  return (
    <PanelModal
      closeModal={closeModal}
      closeButtonRobotTag="chat-error-modal-close-button"
    >
      {showHeading && (
        <ErrorHeading>
          <FormattedMessage
            id="chat.chatSendError"
            defaultMessage="Message not sent"
          />
        </ErrorHeading>
      )}

      <ErrorBody>{children}</ErrorBody>
    </PanelModal>
  )
}

export default ErrorModal
